// Canonical checkout-domain vocabulary (business portal mirror).
// Mirrors: backend/src/constants/checkout.js, src/constants/checkout.ts (consumer app).
// Wire values are FROZEN — see backend file for the rules.

export const VENUE_MODE = {
  PARTNER: 'partner',
  REQUEST_TO_BOOK: 'request_to_book',
  NATIVE: 'native',
  UNKNOWN: 'unknown',
} as const;
export type VenueMode = (typeof VENUE_MODE)[keyof typeof VENUE_MODE];

export const PAYMENT_FLOW = {
  EXTERNAL_HOLD: 'manual',
  PARTNER_CONNECT: 'request_to_book_deferred',
  PLATFORM_COLLECT: 'partner_platform_collect',
  NATIVE_INSTANT: 'native_instant',
} as const;
export type PaymentFlow = (typeof PAYMENT_FLOW)[keyof typeof PAYMENT_FLOW];

export const DEFERRED_CARD_FLOWS: readonly PaymentFlow[] = [
  PAYMENT_FLOW.PARTNER_CONNECT,
  PAYMENT_FLOW.PLATFORM_COLLECT,
];

export function isDeferredCardFlow(flow: string | null | undefined): boolean {
  return DEFERRED_CARD_FLOWS.includes(flow as PaymentFlow);
}

export const BOOKING_STATUS = {
  CHECKOUT_PENDING: 'checkout_pending',
  PENDING_APPROVAL: 'pending_approval',
  APPROVED: 'approved',
  DECLINED: 'declined',
  CANCELED: 'canceled',
  EXPIRED: 'expired',
  COMPLETED: 'completed',
} as const;
export type BookingStatus = (typeof BOOKING_STATUS)[keyof typeof BOOKING_STATUS];

export const PAYMENT_STATUS = {
  PENDING: 'pending',
  REQUIRES_ACTION: 'requires_action',
  REQUIRES_CAPTURE: 'requires_capture',
  PROCESSING: 'processing',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
  CANCELED: 'canceled',
  REFUNDED: 'refunded',
} as const;
export type PaymentStatus = (typeof PAYMENT_STATUS)[keyof typeof PAYMENT_STATUS];
